import { Encoding, getEncodingString } from "./encoding";

type BOM = Uint8Array;

export class Decoder {
  private _encoding: Encoding;

  private _bom: BOM | null;

  private _decoder: TextDecoder;

  constructor(encoding: Encoding, bom: BOM | null) {
    this._encoding = encoding;
    this._bom = bom;
    this._decoder = new TextDecoder(
      this.isUTF16BE ? "utf-16le" : getEncodingString(encoding)
    );
  }

  private get isUTF16BE() {
    return this._encoding === Encoding.UTF16BE;
  }

  decode(data: Uint8Array): string {
    let contentBuffer = data.slice(this._bom?.length);

    if (this.isUTF16BE) contentBuffer = swap16(contentBuffer);

    return this._decoder.decode(contentBuffer);
  }
}

function swap16(uint8Array: Uint8Array) {
  let res = uint8Array;
  if (res.length % 2 !== 0) {
    throw new RangeError("Buffer size must be a multiple of 16-bits");
  }

  for (let i = 0; i < res.length; i += 2) {
    const temp = res[i];
    res[i] = res[i + 1];
    res[i + 1] = temp;
  }

  return res;
}
